import React, {useEffect} from "react";
import {OfferForm, OfferRequestPartial} from "./createAndUpdate/OfferForm";
import {createOfferRequestPropertySelector} from "./selector/OfferStoreSelector";
import {useAppDispatch, useAppSelector} from "../../../../app/hooks";
import {RequestStatus} from "../../../../api/apiConfiguration";
import {
    showErrorToastNotification,
    showSuccessToastNotification
} from "../../../elements/toastNotification/toastNotificationSlice";
import {
    clearCreateOfferState,
    createOffer,
    createOfferRequestSelector,
    createOfferRequestStatusSelector,
    updateCreateOfferRequest
} from "../offerCreateSlice";
import {fetchOfferList, offerTableRequestSelector} from "../offerListSlice";

interface CreateOfferFormProps {
    publicBotId?: string
    publicLocationId?: string
    handleClose: () => void
}

export const CreateOfferForm: React.FC<CreateOfferFormProps> = ({
                                                                    publicBotId,
                                                                    publicLocationId,
                                                                    handleClose
                                                                }) => {

    const dispatch = useAppDispatch()
    const createOfferRequestStatus = useAppSelector(createOfferRequestStatusSelector)
    const offerTableRequest = useAppSelector(offerTableRequestSelector)

    useEffect(() => {
        if (publicBotId) {
            dispatch(updateCreateOfferRequest({publicBotId}))
        }
        if (publicLocationId) {
            dispatch(updateCreateOfferRequest({publicLocationId}))
        }
        return () => {
            dispatch(clearCreateOfferState());
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (createOfferRequestStatus === RequestStatus.RESOLVED) {
            if (publicBotId) {
                dispatch(fetchOfferList({...offerTableRequest, publicBotId}))
            }
            handleClose()
            dispatch(showSuccessToastNotification({message: "Offer Created Successfully"}))
        } else if (createOfferRequestStatus === RequestStatus.REJECTED) {
            dispatch(showErrorToastNotification({message: "Failed to create offer"}))
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [createOfferRequestStatus]);

    const updateRequest = (update: OfferRequestPartial) => {
        dispatch(updateCreateOfferRequest(update))
    }

    const onSubmit = () => {
        dispatch(createOffer())
    }

    const formTitle = publicBotId ? "Create offer for bot" : "Create offer for location"

    return <OfferForm
        formTitle={formTitle}
        onClose={handleClose}
        onSubmit={onSubmit}
        updateRequest={updateRequest}
        selectionProvider={createOfferRequestPropertySelector(createOfferRequestSelector)}
    />
}
